import React, { useEffect, useState } from "react";
import { getContractsByID, getPackagesByID } from "../../api/user";
import { useTranslation } from "react-i18next";
import { useMessenger } from "../../context/messengerContext";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

import BasicDropdown from "../../components/inputs/basicDropdown/basicDropdown";
import BasicPanel from "../../components/panels/basicPanel/basicPanel";
import StepsHeader from "./utils/stepsHeader";
import TrackItem from "./trackItem";

import "./packageTracking.css";

const TrackPackage = () => {
  const { t } = useTranslation('basic');
  const { userId, platform } = useMessenger();

  const [contracts, setContracts] = useState([]);
  const [selectedContract, setSelectedContract] = useState("");
  const [packageInfos, setPackageInfos] = useState([]);
  const [error, setError] = useState(null);
  const [groupedByUser, setGroupedByUser] = useState({});

  const [expandedUsers, setExpandedUsers] = useState([]);

  const [role] = useState("admin"); // или "employee"

  // загрузка контрактов пользователя
  useEffect(() => {
    if (!userId && userId !== 0) return;
    getContractsByID({ platform, userId })
      .then((res) => {
        const contractOptions = res?.map((contract) => ({
          label: contract,
          value: contract
        })) || [];
        setContracts(contractOptions);
      })
      .catch((e) => {
        console.error("Ошибка при загрузке контрактов:", e);
        setContracts([]);
      });
  }, [platform, userId]);


  // загрузка посылок по выбранному контракту
  useEffect(() => {
    if (!selectedContract) return;

    getPackagesByID({ platform, userId, contract_number: selectedContract })
      .then((res) => {
        if (res?.detail ) {
          setError(res?.detail);
          setPackageInfos([]);
        } else {
          // Приведение к нужной структуре (если нужно)
          let data = [];

          Object.keys(res).forEach((key) => {
            data.push({
              ...res[key]
            });
          })
          setPackageInfos(data);
        }
      })
      .catch((e) => {
        console.error("Ошибка при загрузке посылок:", e);
        setPackageInfos([]);
      });
  }, [platform, selectedContract, userId]);

  useEffect(() => {
    setGroupedByUser(packageInfos.reduce((acc, item) => {
      if (role === "employee") {
        // Bot-tracking uses item.status (DB-stored Russian CDEK status name).
        const itemStatus = item.status || item.name || "";
        if (item.tg_id !== userId || itemStatus !== "В пути") return acc;
      }
  
      if (!acc[item.tg_id]) {
        acc[item.tg_id] = {
          user_name: item.user_name,
          packages: []
        };
      }
  
      acc[item.tg_id].packages.push(item);
      return acc;
    }, {}));
  }, [packageInfos, role, userId]);

  useEffect(() => {
    console.log(groupedByUser);
  }, [groupedByUser]);

  const toggleUserExpand = (userId) => {
    setExpandedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };


  return (
    <>
      <StepsHeader />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          paddingTop: "1.5rem",
          paddingInline: "1rem"
        }}
      >
        <BasicPanel className="trackingPanel">
          <div className="trackingPanelWrapper">
            <BasicDropdown
              label={t("contract_number")}
              placeholder={t("select_contract_number")}
              error={error?.contract_number}
              data={contracts}
              onChange={(val) => setSelectedContract(val)}
              value={selectedContract}
            />
          </div>
        </BasicPanel>

        {/* Группировка по пользователям */}
        {Object.entries(groupedByUser).map(([userId, group]) => (
          <div key={userId} style={{
            marginBottom: "1rem"
          }}>
            {/* Показывать имя только если admin */}
            {role === "admin" && (
            <div
              onClick={() => toggleUserExpand(userId)}
              style={{
                fontWeight: "bold",
                fontSize: "1rem",
                marginBottom: "0.5rem",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem"
              }}
            >
              {group.user_name || t("employee_word")}
              <span>
              {expandedUsers.includes(userId)
                ? <FaChevronDown size={12} />
                : <FaChevronRight size={12} />}
            </span>
            </div>
          )}
          {expandedUsers.includes(userId) && (
            <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
              {group.packages.map((item) => (
                <TrackItem key={item.track_number} track_data={item} />
              ))}
            </div>
          )}

          </div>
        ))}
      </div>
    </>
  );
};

export default TrackPackage;
